module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAVUlEQVQ4y2NgGBTg95Vr/z8lZ/z/4O4DpkH8MwwMBDHcgF/HTvx/I6MMxyA+SQaAbEQ2YGBc8FbLEBwGIHqYuIBhJgNhjC8WSDKAKi5AT4kkGTC0AQCFb0ThkOgGmwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/BY.png
// module id = 1101
// module chunks = 0